<template>
  <div class="accuracy-survey-flow">
    <riseup-header/>
    <nps v-if="isNPSQuestion"
                      @new-survey-question="newSurveyQuestion" @next-clicked="nextClicked"/>
    <radio-button-survey v-else-if="!surveyDone"
                           v-bind="question"
                           :total-questions="totalQuestions"
                           :useTextAnswer="true"
                           @new-survey-question="newSurveyQuestion" @next-clicked="nextClicked"/>
    <alert-page v-else :emoji="'🙏'"
                :title="'תודה!'"
                :showButton="false">
      <template v-slot:content>התשובות שלך עוזרות לנו להמשיך ולבנות את השירות הטוב ביותר בשבילך</template>
    </alert-page>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import Segment from '../../../../../Segment';
import RadioButtonSurvey from '../../../../../base-components/survey/RadioButtonSurvey.vue';
import AlertPage from '../../../../../base-components/AlertPage.vue';
import RiseupHeader from '../../../../../base-components/app-header/RiseupHeader.vue';
import nps from './NPS.vue';
import questions from './consts/accuracy-questions';

export default {
  name: 'AccuracySurveyFlow',
  components: {
    RadioButtonSurvey,
    RiseupHeader,
    AlertPage,
    nps,
  },
  props: {
    questionName: {
      type: String,
      required: true,
    },
  },
  created() {
    this.gotoPage(questions.QUESTION_NAMES.NPS);
  },
  computed: {
    ...mapState('session', ['customerId']),
    ...mapGetters('accuracySurvey', ['questionIndex', 'currentQuestion']),
    question() {
      return { ...this.currentQuestion, index: this.questionIndex };
    },
    isNPSQuestion() {
      return this.currentQuestion && this.currentQuestion.name === questions.QUESTION_NAMES.NPS;
    },
    totalQuestions() {
      return questions.QUESTIONS.length;
    },
    surveyDone() {
      return this.questionName === 'done';
    },
  },
  methods: {
    ...mapActions('accuracySurvey', ['nextPage', 'gotoPage']),
    newSurveyQuestion() {
      const { name: questionName } = this.currentQuestion;
      Segment.trackUserInteraction(`AccuracySurvey${questionName}Entered`, { questionIndex: this.questionIndex, questionName });
    },
    nextClicked({ answer, textAnswer }) {
      const { name: questionName } = this.currentQuestion;
      Segment.trackUserInteraction(`AccuracySurvey${questionName}AnswerClicked`, {
        questionIndex: this.questionIndex, questionName, answer, textAnswer,
      });
      Segment.identifyCustomer(this.customerId, { [`AccuracySurvey${questionName}`]: answer });
      this.nextPage({ questionName, answer, textAnswer });
    },
  },
  watch: {
    questionName(newQuestionName) {
      this.gotoPage(newQuestionName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../scss/mixins';

.accuracy-survey-flow {
  @include white-page-frame;
  height: 100%;
}
</style>
